import React from "react";

const WalletIcon = (props) => {
  return (
    <svg
      {...props}
      fill="#000000"
      width="15"
      height="15"
      viewBox="0 0 60 60"
      id="Capa_1"
      version="1.1"
    >
      <g>
        <path d="M46,30c0,2.757,2.243,5,5,5s5-2.243,5-5s-2.243-5-5-5S46,27.243,46,30z M54,30c0,1.654-1.346,3-3,3s-3-1.346-3-3   s1.346-3,3-3S54,28.346,54,30z" />

        <path d="M56.524,6h-6H3.476C1.559,6,0,7.56,0,9.476v41.049C0,52.44,1.559,54,3.476,54h47.049h6C58.44,54,60,52.44,60,50.524V39v-2   V23v-2V9.476C60,7.56,58.44,6,56.524,6z M3.476,52C2.662,52,2,51.338,2,50.524V9.476C2,8.662,2.662,8,3.476,8h47.049   C51.338,8,52,8.662,52,9.476V21h-1c-4.962,0-9,4.037-9,9s4.038,9,9,9h1v11.524C52,51.338,51.338,52,50.524,52H3.476z M58,50.524   C58,51.338,57.338,52,56.524,52h-2.854c0.009-0.019,0.012-0.041,0.021-0.06c0.065-0.145,0.111-0.297,0.155-0.452   c0.022-0.077,0.054-0.149,0.071-0.229C53.97,51.022,54,50.777,54,50.524V39h4V50.524z M58,37h-4h-2h-1c-3.859,0-7-3.141-7-7   s3.141-7,7-7h1h2h4V37z M54,21V9.476c0-0.253-0.03-0.498-0.082-0.735c-0.017-0.079-0.049-0.152-0.071-0.229   c-0.045-0.154-0.091-0.307-0.155-0.452C53.683,8.041,53.68,8.019,53.671,8h2.854C57.338,8,58,8.662,58,9.476V21H54z" />

        <path d="M48.29,41.13c-0.181,0.18-0.29,0.439-0.29,0.7c0,0.27,0.109,0.52,0.29,0.71c0.189,0.189,0.45,0.29,0.71,0.29   s0.52-0.101,0.71-0.29C49.89,42.35,50,42.1,50,41.83c0-0.261-0.11-0.521-0.29-0.7C49.33,40.75,48.66,40.75,48.29,41.13z" />

        <path d="M49,44.42c-0.55,0-1,0.439-1,1c0,0.55,0.45,1,1,1s1-0.45,1-1C50,44.859,49.55,44.42,49,44.42z" />

        <path d="M48.29,48.29C48.109,48.479,48,48.74,48,49s0.109,0.52,0.29,0.7C48.479,49.89,48.729,50,49,50c0.26,0,0.52-0.11,0.71-0.29   C49.89,49.52,50,49.26,50,49s-0.11-0.521-0.29-0.71C49.33,47.92,48.66,47.92,48.29,48.29z" />

        <circle cx="25" cy="49" r="1" />

        <circle cx="21" cy="49" r="1" />

        <circle cx="29" cy="49" r="1" />

        <circle cx="13" cy="49" r="1" />

        <circle cx="9" cy="49" r="1" />

        <circle cx="17" cy="49" r="1" />

        <circle cx="41" cy="49" r="1" />

        <circle cx="33" cy="49" r="1" />

        <circle cx="45" cy="49" r="1" />

        <circle cx="37" cy="49" r="1" />

        <path d="M4.29,48.29C4.11,48.479,4,48.74,4,49s0.11,0.52,0.29,0.71C4.48,49.89,4.74,50,5,50c0.26,0,0.52-0.11,0.71-0.29   C5.89,49.52,6,49.26,6,49s-0.11-0.521-0.29-0.71C5.33,47.92,4.67,47.92,4.29,48.29z" />

        <circle cx="5" cy="14.8" r="1" />

        <circle cx="5" cy="18.6" r="1" />

        <circle cx="5" cy="33.8" r="1" />

        <circle cx="5" cy="26.2" r="1" />

        <circle cx="5" cy="22.399" r="1" />

        <circle cx="5" cy="37.6" r="1" />

        <circle cx="5" cy="30" r="1" />

        <circle cx="5" cy="41.399" r="1" />

        <circle cx="5" cy="45.2" r="1" />

        <path d="M4.29,10.29C4.11,10.479,4,10.729,4,11c0,0.26,0.11,0.52,0.29,0.7C4.48,11.89,4.73,12,5,12c0.26,0,0.52-0.11,0.71-0.29   C5.89,11.52,6,11.26,6,11s-0.11-0.521-0.29-0.71C5.33,9.92,4.66,9.92,4.29,10.29z" />

        <circle cx="41" cy="11" r="1" />

        <circle cx="45" cy="11" r="1" />

        <circle cx="29" cy="11" r="1" />

        <circle cx="33" cy="11" r="1" />

        <circle cx="25" cy="11" r="1" />

        <circle cx="37" cy="11" r="1" />

        <circle cx="17" cy="11" r="1" />

        <circle cx="13" cy="11" r="1" />

        <circle cx="9" cy="11" r="1" />

        <circle cx="21" cy="11" r="1" />

        <path d="M49,12c0.26,0,0.52-0.11,0.71-0.29C49.89,11.52,50,11.26,50,11c0-0.271-0.11-0.521-0.29-0.71c-0.38-0.37-1.05-0.37-1.42,0   C48.109,10.479,48,10.74,48,11s0.109,0.52,0.29,0.7C48.479,11.89,48.729,12,49,12z" />

        <path d="M49,15.58c0.55,0,1-0.44,1-1c0-0.55-0.45-0.99-1-0.99s-1,0.44-1,0.99C48,15.14,48.45,15.58,49,15.58z" />

        <path d="M49,19.17c0.27,0,0.52-0.11,0.71-0.3c0.18-0.181,0.29-0.44,0.29-0.7c0-0.271-0.11-0.521-0.29-0.71   c-0.37-0.37-1.05-0.37-1.41,0c-0.19,0.18-0.3,0.439-0.3,0.71c0,0.27,0.109,0.52,0.29,0.7C48.479,19.06,48.729,19.17,49,19.17z" />
      </g>

      <g />

      <g />

      <g />

      <g />

      <g />

      <g />

      <g />

      <g />

      <g />

      <g />

      <g />

      <g />

      <g />

      <g />

      <g />
    </svg>
  );
};

export default WalletIcon;
